export default __webpack_public_path__ + "static/media/chevron-right-circle-fill.e0729388.svg";